import React, {
  useContext,
  createContext,
  useState,
  useEffect,
  useRef,
} from "react";

import { useIntl } from "react-intl";
import { DateTime } from "luxon";
import { useMutation } from "react-query";
import axios, { AxiosResponse } from "axios";
import Swal from "sweetalert2";

import UserContext from "../contexts/user";
import getEncodedImageUrl from "../helpers/get-encoded-image";

import Footer from "../components/footer";

import Login from "../components/auth/login";
import Signup from "../components/auth/signup";
import { Button } from "reactstrap";
import { string, TypeOf } from "yup";
import { useHistory, useParams } from "react-router-dom";
import ForgotPassword from "../components/auth/forgot-password";
import ResetPassword from "../components/auth/reset-password";
import ValidateUser from "../components/auth/validate-user";

interface LoginMutate {
  login?: string;
  email?: string;
  password?: string;
  mode?: string;
}

export const AuthContext = createContext({
  page: "login",
  setPage: (s: string) => {},
  login: {
    mutate: (args: LoginMutate) => {},
    isLoading: false,
  },
});

const UserAuth: React.FC = () => {
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const [page, setPage] = useState("login");
  // const { event_slug } = useParams<{
  //   event_slug: string
  // }>();
  const [email, setEmail] = useState<LoginMutate>({ email: "", password: "" });
   console.log("setEmail", email);
   console.log("email.email , email.password", email.email, email.password);

  const history = useHistory();

  const [check, setCheck] = useState({});
  const userDetails = useRef<LoginMutate>({ email: "", password: "" });
  const { setUser, setListUser } = userContext;
  // const [resettoken, setResetToken] = useState(token)
  //
  // const [token, setToken] = React.useState(
  //   document.location.search.indexOf("resettoken") !== -1
  //     ? document.location.search.split("=")[1]
  //     : null
  // );
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const resetToken = urlParams.get("resettoken");
    const resetCode = urlParams.get("resetcode");
     console.log("resetcode---------------", resetCode);
    if (resetToken) {
      setPage("resetpassword");
    } else if (resetCode) {
      setPage("validateuser");
    } else {
      setPage("login");
    }

    // setPage("login");
  }, []);
  //  console.log("token for forget password", token);

  //

  const login = useMutation<any, any, LoginMutate>(
    async ({ email, password }) => {
       console.log("email , password", email, password);

       console.log("userContext.redirectPath", userContext.redirectPath);

      userDetails.current.email = email || userDetails.current.email;
      userDetails.current.password = password || userDetails.current.password;

       console.log(userContext.currentEvent._id);
      return axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_ENDPOINT}/api/event-engagement/${userContext.currentEvent._id}/user-login`,
        data: {
          email,
          password,
        },
      });
    },
    {
      onError: (error) => {

        Swal.fire({
          title: "Error!",
          text: intl.formatMessage({ id: error.response.data.message }),
          icon: "error",
        });
      },
      onSuccess: (response) => {

        const { token, id, user } = response.data;
         console.log("User Data 2 FF ", response.data);
        if (user?.is_speaker) {
          // let uemail: LoginMutate['email'];
          // let upassword: LoginMutate['password'];
          //  console.log("uemail,upassword",uemail,upassword)

          //  console.log("emailinside2ndcall",email.email,email.password)
          axios
            .post(`${process.env.REACT_APP_API_ENDPOINT}/api/speaker/login`, {
              email: userDetails.current.email,
              password: userDetails.current.password,
              // event_slug: string,
              event_slug: document.location.pathname.split("/")[1] || "invalid",
            })
            .then((res) => {


              // localStorage.setItem("SavedToken", 'Bearer ' + token);
              localStorage.setItem(
                `token-${
                  document.location.pathname.split("/")[1] || "invalid"
                }`,
                res.data.jwt
              );

               console.log("Upload PDF : ",res.data.jwt)
               setListUser(JSON.stringify({ token, id, user }));

                console.log("User Data : ",res.data.data)
                console.log("User Data  2: ",JSON.stringify({ token, id, user }))
                console.log("User Data  2: ",JSON.stringify({ token }))

               setUser(res.data.user);


          setListUser(JSON.stringify({ token, id, user }));
          setUser(user);
           console.log("userContext.redirectPath 3", userContext.redirectPath);

          if (userContext.redirectPath) {
             console.log("inside usercontext redirect path ");
            history.push(userContext.redirectPath);
            let redirectPath = userContext.redirectPath;
            window.location.href = redirectPath;
          }else{
            window.location.reload();
          }
            });
        }
        else{
          setListUser(JSON.stringify({ token, id, user }));
          setUser(user);
           console.log("User Data  2: ",JSON.stringify({ token, id, user }))
           console.log("userContext.redirectPath 3", userContext.redirectPath);

            localStorage.setItem(
                `token-${
                    document.location.pathname.split("/")[1] || "invalid"
                }`,
                token
            );

          if (userContext.redirectPath) {
             console.log("inside usercontext redirect path ");
            history.push(userContext.redirectPath);
            let redirectPath = userContext.redirectPath;
           window.location.href = redirectPath;
          }else{
           window.location.reload();
          }

        }


        //  else {
        //setListUser(JSON.stringify({ token, id, user }));
        // setUser(response.data.data);
        // }

        // setCheck({ token, id, user });

        //get this data while calling user-login api



      },
    }
  );

   console.log("setUser" + setUser);
   console.log("check" + check);

  // if(user?.is_speaker)
  // {
  //   login = useMutation<any, any, LoginMutate>(
  //     async ({ email, password }) => {

  //        console.log(
  //         "-----------------------------------------i am here in onRequest-------------------------------------------------------"
  //       );
  //        console.log(userContext.currentEvent._id);
  //       return axios({
  //         method: "POST",
  //         url: `${process.env.REACT_APP_API_ENDPOINT}/api/event-engagement/${userContext.currentEvent._id}/speaker/login`,
  //         data: {
  //           email,
  //           password,
  //         },
  //       });
  //     },
  //     {
  //       onError: (error) => {
  //          console.log(
  //           "-----------------------------------------i am here in onError-------------------------------------------------------"
  //         );
  //         Swal.fire({
  //           title: "Error!",
  //           text: intl.formatMessage({ id: error.response.data.message }),
  //           icon: "error",
  //         });
  //       },
  //       onSuccess: (response) => {

  //          console.log(
  //           "-----------------------------------------i am here in onSuccess-------------------------------------------------------"
  //         );
  //         const { token, id, user } = response.data;

  //         setListUser(JSON.stringify({ token, id, user }));
  //         setUser(response.data.data);
  //       },
  //     }
  //   );

  // }

   console.log("page", page);
  return (
    <AuthContext.Provider value={{ page, setPage, login }}>
      <div className="login-landing">
        <div className="login-container">
          <div className="login">
            {userContext.currentEvent.allowAnonymousAccess && (
              <Button
                onClick={function () {
                  const event_slug =
                    document.location.pathname.split("/")[1] || "invalid";
                  window.history.replaceState(
                    null,
                    "ESlides Schedule",
                    "/" + event_slug
                  );
                  userContext.setOneTimeShowLogin(false);
                  userContext.setShowLogin(false);
                }}
                className="close"
                color="link"
              >
                <img src="/icons/close.svg" alt="close" />
              </Button>
            )}
            {userContext.currentEvent.logo && (
              <img
                width={120}
                height={60}
                src={getEncodedImageUrl(
                  userContext.currentEvent.logo,
                  110,
                  60,
                  "contain"
                )}
                alt={`${userContext.currentEvent.name} logo`}
              />
            )}
            <h5>{userContext.currentEvent.name}</h5>
            <small>
              {DateTime.fromISO(`${userContext.currentEvent.start}`)
                .setLocale(intl.locale)
                .toFormat("dd LLLL yyyy")}
            </small>
            {/* {token && (
              <ResetPassword token={token} setToken={setToken} />
            )} */}
            {page === "login" && <Login />}
            {page === "signup" && <Signup />}
            {page === "forgotpassword" && <ForgotPassword />}
            {page === "resetpassword" && <ResetPassword />}
            {page == "validateuser" && <ValidateUser />}
          </div>
        </div>
        <Footer />
      </div>
    </AuthContext.Provider>
  );
};

export default UserAuth;
